import React, { lazy, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { PUBLIC_PREFIX_PATH } from "configs/AppConfig";
import { PublicRoute } from "shared/PublicRoute";

export const PublicViews = () => {
  return (
    <Suspense fallback={<Loading cover="page" />}>
      <Switch>
        <PublicRoute
          path={`${PUBLIC_PREFIX_PATH}/mobile-auth`}
          component={lazy(
            () => import(`../loyalty-app/app-loyalty-views/Cart/mobileHandoff`)
          )}
          exact
        />
        <PublicRoute
          path={`${PUBLIC_PREFIX_PATH}/virtual-consult/`}
          component={lazy(() => import(`./VirtualConsultPage`))}
        />
        <PublicRoute
          path={`${PUBLIC_PREFIX_PATH}/scheduler/:id`}
          component={lazy(
            () => import(`../app-views/CalendarPage/Scheduler/PublicScheduler`)
          )}
          exact
        />
        <PublicRoute
          path={`${PUBLIC_PREFIX_PATH}/scheduler/link/expired`}
          component={lazy(
            () =>
              import(
                `../app-views/CalendarPage/Scheduler/PublicSchedulerExpired`
              )
          )}
          exact
        />
        <PublicRoute
          path={`${PUBLIC_PREFIX_PATH}/booking/scheduler`}
          component={lazy(() => import(`./BookingScheduler`))}
        />
        <PublicRoute
          path={`${PUBLIC_PREFIX_PATH}/scheduler`}
          component={lazy(() => import(`./StandAlonePublicScheduler`))}
        />
        <PublicRoute
          path={`${PUBLIC_PREFIX_PATH}/gift-cards/:id`}
          component={lazy(() => import(`./PublicGiftCardReveal`))}
          exact
        />
        <Route
          path={`${PUBLIC_PREFIX_PATH}/payment-link/:code`}
          component={lazy(() => import(`./PublicPaymentLink`))}
          exact
        />
      </Switch>
    </Suspense>
  );
};

export default PublicViews;
